import React, {Component} from 'react';
import {connect} from 'react-redux';

import NewNonEngineer from './NewNonEngineerContainer';
import NonEngineers from '../shared/NonEngineers';

import {
    fetchContractorPreferences,
    fetchContractorNonEngineers,
    updateContractorNonEngineer,
    uploadContractorNonEngineerDocument,
    deleteContractorNonEngineerDocument,
} from '../../actions';

class NonEngineersContainer extends Component {
    componentDidMount() {
        const {belongsTo, fetchContractorPreferences} = this.props;
        return fetchContractorPreferences(belongsTo);
    }
    render() {
        const generateUrl = (belongsTo, nonEngineer, doc) => {
            return `/api/contractor/${belongsTo}/non-engineer/${nonEngineer}/documents/${doc}`;
        };
        return <NonEngineers NewNonEngineer={NewNonEngineer} generateDocUrl={generateUrl} {...this.props}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        belongsTo: state.me.contractor_id,
        engineers: state.contractor.nonEngineers,
        settings: state.contractor.preferences.data
    }
};

export default connect(mapStateToProps, {
    fetchContractorPreferences,
    fetchNonEngineers: fetchContractorNonEngineers,
    updateNonEngineer: updateContractorNonEngineer,
    uploadNonEngineerDocument: uploadContractorNonEngineerDocument,
    deleteNonEngineerDocument: deleteContractorNonEngineerDocument
})(NonEngineersContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/NonEngineersContainer.js